<script>
import { fade } from 'svelte/transition'
import { onInterval } from '../clockutil.js';



let piano = new Audio('audio/gauss.mp3');
piano.volume = 0;
piano.play();

var x = 99;
var interval = 25;

for (var i = 0; i < x; i++) {
    setTimeout(function () {
        piano.volume+=0.01;
    }, i * interval)
}


</script>

<style>
p {
  position: absolute;
  top:0;
  padding-top: 70px;
  font-family: monospace;
  font-size: 14px;
  z-index: 2;
  padding-bottom: 150px;
}

.fillbox {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
  background-image: url('/img/hell.jpg');
  top: 0;
  left: 0;
  filter: contrast(900%) brightness(20%);
  mix-blend-mode: difference;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>

<p transition:fade>My descent had begun</p>
<div class='fillbox' transition:fade></div>
